import { render, staticRenderFns } from "./healthInfoModule.vue?vue&type=template&id=62764608&scoped=true"
import script from "./healthInfoModule.vue?vue&type=script&lang=js"
export * from "./healthInfoModule.vue?vue&type=script&lang=js"
import style0 from "./healthInfoModule.vue?vue&type=style&index=0&id=62764608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62764608",
  null
  
)

export default component.exports